// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "app_api-" + chunkId + ".js?v=" + {"node_modules_nextcloud_dialogs_dist_chunks_index-C1azEbgd_mjs":"aa8614dd8b8a64a2d1a0","vendors-node_modules_nextcloud_dialogs_dist_chunks_FilePicker-CDU2njOJ_mjs":"38a23ad10cca63c27c21"}[chunkId] + "";
};